import { roleCode } from "../../utils/constants";

export const checkIfRoleHasRights =  (userRoleCode, groupRoles) => {    
    let userHasRights = groupRoles.includes(userRoleCode);    
    if(userHasRights){
        return true;
    }
    else {        
        return false;
    }
}

export const group1Rights = (curentUserData) => {    
    let groupRoles = [roleCode.superAdmin, roleCode.admin ]
    if (curentUserData) {        
       return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);     
    }
}

export const group2Rights = (curentUserData) => {    
    let groupRoles = [roleCode.superAdmin, roleCode.admin, roleCode.operator ]
    if (curentUserData) {        
       return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);     
    }
}

export const group3Rights = (curentUserData) => {    
    let groupRoles = [roleCode.superAdmin, roleCode.admin, roleCode.utenteCna ]
    if (curentUserData) {        
       return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);     
    }
}


export const isArchivio = (curentUserData) => {
    let groupRoles = [roleCode.archivio]
    if (curentUserData) {
        return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);            
    }
}

export const isOperator= (curentUserData) => {
    let groupRoles = [roleCode.operator]
    if (curentUserData) {
        return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);            
    }
}

export const isSuperAdmin = (curentUserData) => {
    let groupRoles = [roleCode.superAdmin]
    if (curentUserData) {
        return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);            
    }
}

export const isUtenteCna = (curentUserData) => {
    let groupRoles = [roleCode.utenteCna]
    if (curentUserData) {
        return checkIfRoleHasRights(curentUserData.roleCode, groupRoles);            
    }
}